import { render, staticRenderFns } from "./QuienesSomos.vue?vue&type=template&id=3d77aebc&scoped=true&"
import script from "./QuienesSomos.vue?vue&type=script&lang=js&"
export * from "./QuienesSomos.vue?vue&type=script&lang=js&"
import style0 from "./QuienesSomos.vue?vue&type=style&index=0&id=3d77aebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77aebc",
  null
  
)

export default component.exports